type DynamicImagePauseController = {
  pause: () => boolean | Promise<boolean>
  resume: () => void
}

let controller: DynamicImagePauseController | null = null

export const registerDynamicImagePauseController = (nextController: DynamicImagePauseController) => {
  controller = nextController
}

export const withDynamicImagePaused = async <T>(task: () => T | Promise<T>): Promise<Awaited<T>> => {
  const shouldResume = (await controller?.pause()) ?? false
  try {
    return await task()
  } finally {
    if (shouldResume) {
      controller?.resume()
    }
  }
}

export const acquireDynamicImagePause = async (): Promise<() => void> => {
  const shouldResume = (await controller?.pause()) ?? false
  let released = false
  return () => {
    if (released) {
      return
    }
    released = true
    if (shouldResume) {
      controller?.resume()
    }
  }
}
